<div class="cart-wishlist-container">
  <h4>{{ 'cartWishlist.title' | cxTranslate }}</h4>
  <div class="cart-wishlist-border">
    <div class="cart-wishlist-form">
      @if (wishList$ | async; as wishList) {
        @if (wishList?.entries?.length > 0) {
          <form (ngSubmit)="onSubmit()" #wishlistProductsForm="ngForm" autocomplete="off">
            @for (entry of wishList?.entries; track entry; let i = $index) {
              <div>
                <div class="cart-wishlist-item">
                  <div class="form-check">
                    <input type="checkbox" class="form-control" ngModel name="{{i}}" (change)="handleWishlistButton()" [disabled]="isRestricted">
                  </div>
                  <app-uig-marketplace-icon [marketplace]="entry?.product?.marketplace" [vendor]="entry?.product?.vendor"></app-uig-marketplace-icon>
                  {{entry?.product.manufacturer}}&nbsp;
                  {{entry?.product.name}},&nbsp;
                  {{entry?.product.ekPrice?.formattedValue}}
                </div>
              </div>
            }
            <div class="row cart-wishlist-action">
              <div class="col-md-4 col-lg-10">
                <button class="btn btn-secondary btn-block" type="submit" [disabled]="disableButton || isRestricted">
                  {{ 'cartWishlist.submit' | cxTranslate }}
                </button>
              </div>
            </div>
          </form>
        } @else {
          <p class="cart-wishlist-empty">{{ 'cartWishlist.empty' | cxTranslate }}</p>
        }
      }

    </div>
  </div>
</div>
